module.exports = __webpack_public_path__ + "static/img/map_logo.4800ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/map_logo.png
// module id = Jmm/
// module chunks = 51